import { useStore } from '@proscom/prostore-react';
import { LocationStore } from '@proscom/prostore-react-router';
import { STORE_LOCATION } from '../store/stores';

export function useQuery() {
  const [{ query }, { changeQuery }] = useStore<LocationStore>(STORE_LOCATION);

  return [query, changeQuery] as const;
}
